import {
	DeleteButton,
	Edit,
	SimpleForm,
	TextInput,
	NumberInput,
	RadioButtonGroupInput,
	minLength,
	ReferenceInput,
	SelectInput,
	required,
	email,
	BooleanInput,
	FormDataConsumer,
	Toolbar,
	SaveButton,
} from 'react-admin'

import Permission from '../../components/Permission';
import { EmailVerificationWarning, ResendEmailButton } from '../../components/EmailVerificationAlerts';
import { MarkVerifiedButton } from '../../components/MarkVerifiedButton';
import { PERMISSIONS } from '../../constants';

const validatePassword = [minLength(6)];
const validateEmail = [required(), email()]

const UserEditToolbar = () => (
	<Toolbar sx={{ gap: 1 }}>
		<SaveButton />
		<ResendEmailButton size="medium" />
		<Permission permission={PERMISSIONS.ADMIN}>
			<MarkVerifiedButton size="medium" />
		</Permission>
		<Permission permission={PERMISSIONS.UPDATE_USER}>
			<DeleteButton mutationMode="pessimistic" redirect="/employees" sx={{ marginLeft: 'auto' }} confirmTitle="Excluir usuário" />
		</Permission>
	</Toolbar>
);

export default props => {
	const transform = data => {
		delete data.profile;
		return data;
	};
	return (
		<Permission permission={PERMISSIONS.UPDATE_USER}>
			<Edit {...props} transform={transform} title="Editar usuário">
				<SimpleForm sx={{ maxWidth: 600 }} toolbar={<UserEditToolbar />}>
					<EmailVerificationWarning />
					<Permission permission={PERMISSIONS.ADMIN} >
						<ReferenceInput {...props} label="Rede" source="chainId" reference="chains" sort={{ field: 'name', order: 'ASC' }} perPage={null} >
							<SelectInput optionText="name" InputProps={{ autoComplete: 'off' }} fullWidth />
						</ReferenceInput>
					</Permission>
					<TextInput source="name" label="Nome" validate={[required()]} InputProps={{ autoComplete: 'off' }} fullWidth />
					<TextInput source="login" label="Login" validate={validateEmail} InputProps={{ autoComplete: 'off' }} fullWidth />
					<TextInput source="password" label="Senha" validate={validatePassword} InputProps={{ autoComplete: 'new-password' }} fullWidth />
					<FormDataConsumer>
						{({ formData }) => (
							<ReferenceInput
								source="profileId"
								reference="profiles"
								sort={{ field: 'name', order: 'ASC' }}
								perPage={9999}
								filter={{ chainId: formData.chainId }}>
								<RadioButtonGroupInput label="Perfil" optionText="name" validate={[required()]} />
							</ReferenceInput>
						)}
					</FormDataConsumer>
					<Permission permission={PERMISSIONS.EDIT_MAX_POINTS}>
						<NumberInput source="maxPoints" label="Pontos por CPF" InputProps={{ autoComplete: 'off' }} fullWidth />
					</Permission>
					<BooleanInput source="mustChangePassword" label="Forçar usuário a trocar senha no primeiro acesso" />
				</SimpleForm>
			</Edit>
		</Permission>
	)
}
